export default {
  name: {
    id: 'rm_metal_hafnium_name',
    defaultMessage: 'Hafnium',
  },
  smartphoneLabel: {
    id: 'rm_metal_hafnium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_hafnium_what_it_does',
    defaultMessage:
      'Hafnium is used mainly in the advanced semiconductor chips found in some smartphones. Hafnium oxide acts as a high-k insulating layer in transistor gates, helping control the flow of electricity, reduce leakage and enable smaller, more energy-efficient transistors. It is used in tiny amounts during chip manufacturing, and its presence depends on the processor technology.',
  },
  extractionText1: {
    id: 'rm_metal_hafnium_extraction_p1',
    defaultMessage:
      'Hafnium is not mined separately. It is recovered as a by-product when zirconium is purified, especially for nuclear applications. Zirconium ores can contain around 1.5% to 3% hafnium. Because the two metals have very similar properties, they must be separated through advanced chemical processing. Only a small fraction of the hafnium contained in zirconium ores is recovered, while most remains in zirconium products or is lost during processing.',
  },
  quickFactText: {
    id: 'rm_metal_hafnium_quick_fact',
    defaultMessage:
      'Only around 69 tonnes of hafnium are produced worldwide each year on average. France and the United States together account for around 95% of refined production.',
  },
  envSummaryText: {
    id: 'rm_metal_hafnium_env_summary',
    defaultMessage:
      'Hafnium is not mined separately. It is recovered as a by-product of zirconium refining, so its environmental footprint largely follows zirconium and heavy-mineral-sands extraction. Mining can disturb land, remove vegetation, generate waste and tailings, and consume water and energy. Separating hafnium from zirconium requires additional metallurgical processing, which can create further chemical and energy impacts.',
  },
  humanSummaryText: {
    id: 'rm_metal_hafnium_human_summary',
    defaultMessage:
      'Hafnium has no separately documented human-impact profile because it is recovered as a by-product of zirconium refining. The main risks therefore arise from zirconium and heavy-mineral-sands mining and processing, where workers may face accidents, dust and chemical exposure, while nearby communities may experience land-use changes, pressure on water resources and disruption to livelihoods. Because the available sources provide limited hafnium-specific social evidence, these impacts should be treated as indirect and uncertain.',
  },
  humanDisplacementText: {
    id: 'rm_metal_hafnium_human_displacement_text',
    defaultMessage:
      'Potential risks include land-ownership conflicts and disputes over site use, particularly where political, religious or heritage claims overlap. However, the study does not document a specific hafnium-mining displacement case.',
  },
  humanLegalText: {
    id: 'rm_metal_hafnium_human_legal_text',
    defaultMessage:
      'US occupational safety standards set an exposure limit of 0.5 mg of hafnium per cubic metre of air, averaged over an eight-hour workday. Elemental hafnium is also flammable and can ignite spontaneously when exposed to air.',
  },
  geoSummaryText: {
    id: 'rm_metal_hafnium_geo_summary',
    defaultMessage:
      'Hafnium supply is highly concentrated and closely linked to the zirconium industry. France and the United States together account for around 95% of refined production in the 2020–2024 average. Because hafnium is recovered as a by-product, supply cannot easily respond to rising demand or disruptions at one of the few refining facilities.',
  },
  geoDugText: {
    id: 'rm_metal_hafnium_geo_dug_text',
    defaultMessage:
      'Hafnium is found in zirconium-bearing mineral sands rather than in dedicated hafnium mines. The main zirconium resources associated with hafnium production are located in South Africa, Australia and Mozambique.',
  },
  geoProcessedText: {
    id: 'rm_metal_hafnium_geo_processed_text',
    defaultMessage:
      'Hafnium is mainly processed in France and the United States, which together accounted for approximately 95% of global processing-stage production on average between 2020 and 2024. Small volumes were also produced in Russia and China. The European Union is assessed as self-sufficient at the processing stage.',
  },
  geoLeverageText: {
    id: 'rm_metal_hafnium_geo_leverage_text',
    defaultMessage:
      'Hafnium creates geopolitical leverage because it is recovered only as a by-product of zirconium purification and refined by a small number of facilities. France and the United States accounted for approximately 95% of processing-stage production, on average, between 2020 and 2024. China has also reportedly added hafnium to its dual-use export-control list in late 2024, meaning that policy changes or disruptions at a small number of facilities could affect availability and prices.',
  },
  supplySummaryText: {
    id: 'rm_metal_hafnium_supply_summary',
    defaultMessage:
      'Hafnium supply is structurally inflexible because the metal is recovered almost entirely as a by-product of zirconium purification. Refined production is limited to a small number of facilities, while hafnium is used in aerospace, semiconductor and nuclear applications. Hafnium demand is expected to increase, which could put additional pressure on a supply chain that cannot rapidly adjust production.',
  },
  supplyReservesText: {
    id: 'rm_metal_hafnium_supply_reserves_text',
    defaultMessage:
      'Global hafnium resources are estimated at around 1 million tonnes of hafnium content, while European reserves are estimated at around 6,800 tonnes. These figures concern hafnium contained in geological resources or zirconium-bearing materials, not directly available reserves of hafnium metal. Only a fraction of the hafnium contained in zirconium ores is recovered.',
  },
  supplyDemandText: {
    id: 'rm_metal_hafnium_supply_demand_text',
    defaultMessage:
      'Around 61% of global hafnium use was in superalloys in 2020. Other uses included plasma-cutting tips, nuclear control rods, catalysts, semiconductors and optical coatings. Total demand is expected to grow with the aerospace, nuclear energy and semiconductor sectors. For clean-energy technologies specifically, demand is projected to increase by approximately 350%, from 0.002 kt in 2025 to 0.009 kt in 2050.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_hafnium_recycling_summary',
    defaultMessage:
      'There is no consolidated information on hafnium recycling. Production waste is likely to be reintroduced into the manufacturing process, but post-use recycling remains very limited. The hafnium end-of-life recycling input rate is estimated at around 1%. However, little to no hafnium is likely to be recovered from post-use products, partly because it is used in very small amounts and may be dispersed or contaminated during use.',
  },
  recyclingInputText: {
    id: 'rm_metal_hafnium_recycling_input_text',
    defaultMessage:
      'Available estimates put hafnium’s end-of-life recycling input rate at around 1%. This is an overall estimate, not a smartphone-specific figure, and it does not indicate how much hafnium is recovered from consumer devices. No reliable data are available on hafnium recycling from smartphones, where hafnium may be used in extremely thin layers in some advanced chips.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_hafnium_recycling_outlook_text',
    defaultMessage:
      'Not currently. Production scrap may be returned to the manufacturing process, but hafnium from end-of-life products is difficult and often uneconomic to recover. Its low concentration in superalloys and its potentially dispersed use in electronic components limit post-use recycling. Recycling therefore makes only a negligible contribution to hafnium supply.',
  },
  footnote1Text1: {
    id: 'rm_metal_hafnium_footnote_1_p1',
    defaultMessage:
      'As hafnium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using a methodology similar to ADEME’s, public sources and AI assistance. The human-impact and geopolitical scores are based on available data for zirconium. These scores therefore carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  footnote2Text1: {
    id: 'rm_metal_hafnium_footnote_2_p1',
    defaultMessage:
      'Hafnium is extracted alongside zirconium and recovered only as a by-product of zirconium refining. Therefore, “Top Mining Countries” should be understood as “Top Producing Countries” for hafnium. The USGS 2025 report provides no data on global primary hafnium production. The figures presented here come from the 2025 SCRREEN3 Hafnium factsheet, which estimates that zirconium-bearing materials typically contain around 2.5% hafnium, corresponding to an approximate zirconium-to-hafnium production ratio of 40:1.',
  },
  mine0Region: {
    id: 'rm_metal_hafnium_mine0_region',
    defaultMessage: 'Albany',
  },
  mine1Region: {
    id: 'rm_metal_hafnium_mine1_region',
    defaultMessage: 'Jarrie',
  },
  mine2Region: {
    id: 'rm_metal_hafnium_mine2_region',
    defaultMessage: 'Ogden',
  },
  mine3Region: {
    id: 'rm_metal_hafnium_mine3_region',
    defaultMessage: 'Glazov',
  },
} as const
